import styled from "styled-components";

export const Container = styled.section`
  position: absolute;
  z-index: 100;

  div {
    &.arrow_cond {
      cursor: auto;
      pointer-events: none;
      z-index: -500;
      path {
        stroke-dasharray: 3;
      }
    }
  }
`;

export const Content = styled.div`
  transform: rotate(45deg);

  border: 1px solid #111;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${({ status }) =>
    status === "done"
      ? "#49B446"
      : status === "late"
        ? "#D93333"
        : status === "doing"
          ? "#EACB29"
          : status === "pending"
            ? "#D4D6DA"
            : null};
`;

export const Anchor = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.top_anchor {
    left: 0;
    top: 0;
  }

  &.bottom_anchor {
    right: 0;
    top: 0;
  }
`;
